import { h } from 'hyperapp';
import { Desktop } from '../../../utils/resizeObserver';
import './filtersDropdown.less';

export const fdState = {
    fdOpened: false,
    counter: 0,
};
export const fdActions = {
    openFiltersDropdown: () => state => ({ ...state, fdOpened: true }),
    closeFiltersDropdown: () => state => ({ ...state, fdOpened: false }),
    toggleFiltersDropdown: () => state => ({ ...state, fdOpened: !state.fdOpened }),
};
export const FiltersDropdown = (
    { fdOpened, counter, toggleFiltersDropdown, headline },
    children
) => (
    <div class={`filter-dropdown${fdOpened ? ' filter-dropdown_state_opened' : ''}`}>
        <Desktop
            render={isDesktop => (
                <div>
                    {!isDesktop ? (
                        <div onclick={toggleFiltersDropdown} class="filter-dropdown__header">
                            <div class="filter-dropdown__icon" />
                            <div class="filter-dropdown__caption">
                                {headline}
                                {counter !== 0 ? (
                                    <div class="filter-dropdown__count">{counter}</div>
                                ) : (
                                    <div />
                                )}
                            </div>
                            <span class="caret" />
                        </div>
                    ) : (
                        <div />
                    )}
                    <div class={isDesktop ? '' : 'filter-dropdown__content'}>{children}</div>
                </div>
            )}
        />
    </div>
);
